import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import './FirstVisit.css';
import Fade from 'react-reveal/Fade';
import ReactGA from 'react-ga';
import { sendToSalesFlow, setDigitalData } from '../../Utilities/Utils.js';

class FirstVisit extends Component {

    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()

        if (this.props.DGRStore.debugMode === false){
            //REQUIRE USER 
            if (!this.props.DGRStore.values.lead_number){
                this.props.DGRStore.clearValues()
                return this.props.history.push('');
            } else {
                this.props.DGRStore.checkIn()
            }
        }
        setDigitalData( 'guest visit selection', this.props.DGRStore.club_number );
    }

    showMyselfClicked = (e) => {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'First Visit',
            action: 'Show Myself Around'
        });
        this.props.DGRStore.trackSelection( this.props.DGRStore.values.lead_number, 'show_myself_around' );
    }

    featuredProductClicked = (e) => {
        var self = this;
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'First Visit',
            action: 'Featured Product Select'
        });
        this.props.DGRStore.trackSelection( this.props.DGRStore.values.lead_number, 'featured_product' );

        e.preventDefault();
        this.props.DGRStore.setValue( 'membership_flow' , true);
        this.props.DGRStore.setProductID( e.currentTarget.name );
        //TODO - possibly bailout function if missing product_id and club_number 
        const { club_product_id, club_number } = this.props.DGRStore 
        const { lead_number, is_waiver_signed } = this.props.DGRStore.values;

        // No lead number means we don't have them signed in with a lead.
        if ( !lead_number ) {
            this.props.history.push('enter_pass');
        // Lead exists, but the waiver isn't signed yet.
        } else if ( !is_waiver_signed ) {
            this.props.history.push('sign_waiver');
        // Lead exists and waiver is signed. Check for product id.
        } else if ( club_product_id && club_number ) {
            // Adding delay so the tracking can fire.
            setTimeout( function() {
                sendToSalesFlow( club_product_id, club_number, self.props.DGRStore.values, self );
            }, 300 );
        // No product selected, so go home and reset.
        } else {
            this.props.DGRStore.clearValues();
            this.props.history.replace('');
        }
    }

    membershipOptionsClicked = (e) => {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'First Visit',
            action: 'Membership Options'
        });
        this.props.DGRStore.trackSelection( this.props.DGRStore.values.lead_number, 'membership_options' );
    }

    talkWithTeamMemberClicked = (e) => {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'First Visit',
            action: 'Talk With Team Member'
        });
        this.props.DGRStore.trackSelection( this.props.DGRStore.values.lead_number, 'talk_with_team_member' );
    }

    renderCommitment() {
        var featuredProduct = this.props.DGRProductStore.featuredProduct;
        if ( featuredProduct.is_commit ) {
            return (
                <div className="optionSubline">
                    { featuredProduct.commitment_months } month commitment required
                </div>
            );
        } else {
            return '';
        }
    }

    render(){
        var featuredProduct = this.props.DGRProductStore.featuredProduct 
        return (
            <div className="firstVisit">
                <Fade>
                <div className="join">  
                    <div className="joinTitleText">
                        <div className="joinTitleTextSub">
                             <h2>How can we help?</h2>
                        </div>
                    </div>
                    <div className="optionsBox">
                        <Link to="/enjoy_visit" onClick={ this.showMyselfClicked }> 
                            <button className="sideButton">
                                <div>I&rsquo;d Like to Show Myself Around</div>
                            </button>
                        </Link>
                        <div className="centerButtons">
                            <Link className="topOptionsButton" to="/membership_options" name={ featuredProduct.id } onClick={ this.featuredProductClicked }> 
                                <div className="optionPrice">
                                    {featuredProduct.monthly_dues}<span className="priceTag">/mo</span>
                                </div>
                                <div className="optionTitle">
                                    { featuredProduct.name }
                                </div>
                                { this.renderCommitment() }
                            </Link>
                            <div className="buttonSep"></div>
                            <Link className="bottomOptionsButton" to="/membership_options" onClick={ this.membershipOptionsClicked }> 
                                <div className="optionSeeAll">
                                    See All Membership 
                                <br/>
                                    Options
                                </div>
                            </Link>
                        </div>
                        <Link to="/enjoy_tour" onClick={ this.talkWithTeamMemberClicked }> 
                            <button className="sideButton">
                                <div>Talk With a Team Member</div>
                            </button>
                        </Link>
                    </div>
                </div>
                </Fade>
            </div>
        )
    }
}

FirstVisit = inject('DGRStore', 'DGRBackgroundStore','DGRProductStore' )(observer(FirstVisit))
export default FirstVisit



// WEBPACK FOOTER //
// ./src/components/DGR/FirstVisit/FirstVisit.js